
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ButtonOptional from '@/components/molecules/ButtonOptional.vue'

/**
 * 学習状況サマリーのコンテンツ
 */
@Component({
  components: {
    ImageBase,
    ButtonOptional,
  },
})
export default class StudySummaryPanelContent extends Vue {
  /** アイコン画像URL */
  @Prop()
  private iconUrl!: string

  /** 通算問題演習回数 */
  @Prop()
  private countTimesStudy!: number

  /** 詳細ボタン押下時のイベント */
  @Prop()
  private eventClickButton!: () => void
}
